import React from "react";
import { Box, Container, Typography, Link as MuiLink } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      id="contact"
      sx={{
        py: 16,
        position: "relative",
        overflow: "hidden",
        borderTop: "1px solid",
        borderColor: "custom.white5",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{ px: 3, position: "relative", zIndex: 10, textAlign: "center" }}
      >
        <Box sx={{ mb: 8 }}>
          <Typography
            sx={{
              fontFamily: "mono",
              color: "primary.main",
              fontSize: "0.875rem",
              mb: 3,
              letterSpacing: "0.5em",
              textTransform: "uppercase",
            }}
          >
            06 // Collaboration
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "3rem", md: "4.5rem" },
              fontWeight: 700,
              mb: 5,
              letterSpacing: "-0.05em",
            }}
          >
            Let's Build Together
          </Typography>
          <Typography
            sx={{
              color: "text.secondary",
              maxWidth: "36rem",
              mx: "auto",
              fontSize: "1.125rem",
              mb: 6,
            }}
          >
            Eager to apply my skills in a challenging role to build innovative
            solutions and contribute to a collaborative development team.
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: "center",
            }}
          >
            <MuiLink
              href="mailto:ahmad@ahmadhanafi.com"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontFamily: "mono",
                color: "inherit",
                textDecoration: "none",
                borderBottom: "2px solid",
                borderColor: "custom.white10",
                pb: 1,
                transition: "color 0.3s",
                "&:hover": { color: "primary.main" },
              }}
            >
              ahmad@ahmadhanafi.com
            </MuiLink>
            <Typography
              sx={{
                fontFamily: "mono",
                color: "text.secondary",
                fontSize: "1.25rem",
              }}
            >
              +46 73 686 92 44
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
            gap: 6,
            pt: 10,
            borderTop: "1px solid",
            borderColor: "custom.white5",
            textAlign: "left",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "mono",
                fontSize: "10px",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                color: "text.secondary",
                display: "block",
                mb: 2,
              }}
            >
              Location
            </Typography>
            <Typography sx={{ fontFamily: "mono", fontSize: "0.875rem" }}>
              Malmo, Sweden
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 4 }}>
            <MuiLink
              href="https://github.com/ahmad-hanafi1"
              target="_blank"
              sx={{
                fontFamily: "mono",
                fontSize: "10px",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Github
            </MuiLink>
            <MuiLink
              href="https://linkedin.com/in/ahmad--hanafi"
              target="_blank"
              sx={{
                fontFamily: "mono",
                fontSize: "10px",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              LinkedIn
            </MuiLink>
          </Box>
          <Box sx={{ textAlign: { md: "right" } }}>
            <Typography
              sx={{
                fontFamily: "mono",
                fontSize: "10px",
                color: "rgba(148, 163, 184, 0.5)",
              }}
            >
              © 2026 AHMAD HANAFI. ALL RIGHTS RESERVED.
            </Typography>
          </Box>
        </Box>
      </Container>

      {/* Decorative Blur Backgrounds */}
      <Box
        sx={{
          position: "absolute",
          bottom: -80,
          right: -80,
          width: 384,
          height: 384,
          bgcolor: "rgba(0, 240, 255, 0.05)",
          borderRadius: "50%",
          filter: "blur(100px)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -80,
          left: -80,
          width: 384,
          height: 384,
          bgcolor: "rgba(0, 240, 255, 0.05)",
          borderRadius: "50%",
          filter: "blur(100px)",
        }}
      />
    </Box>
  );
};

export default Footer;
